<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="storage.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Регион</label>
            <crm-input-text
              [(value)]="storage.region"
              [isError]="$any(errors?.region)"></crm-input-text>
            <small
              *ngIf="errors?.region"
              class="p-error">
              {{ errors.region | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Адрес</label>
            <crm-input-text
              [(value)]="storage.endpoint"
              [isError]="$any(errors?.endpoint)"></crm-input-text>
            <small
              *ngIf="errors?.endpoint"
              class="p-error">
              {{ errors.endpoint | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Ключ доступа</label>
            <crm-input-text
              [(value)]="storage.accessKey"
              [isError]="$any(errors?.accessKey)"></crm-input-text>
            <small
              *ngIf="errors?.accessKey"
              class="p-error">
              {{ errors.accessKey | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Секретный ключ</label>
            <crm-input-text
              [(value)]="storage.secretKey"
              [isError]="$any(errors?.secretKey)"></crm-input-text>
            <small
              *ngIf="errors?.secretKey"
              class="p-error">
              {{ errors.secretKey | join }}
            </small>
          </div>

          <div class="field-checkbox col-12">
            <p-checkbox
              [(ngModel)]="storage.secured"
              [binary]="true"
              inputId="secured"></p-checkbox>
            <label [for]="'secured'">Использовать защищенное соединение</label>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        styleClass="p-button-success"
        [label]="saveButtonLabel"
        (onClick)="saveStorage()"></crm-button>

      <crm-button
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteStorage()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
